import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { Link as ScrollLink } from "react-scroll";
import styles from "./HeroSection.module.css";
import CtaButton from "../components/CtaButton";

const HeroSection = () => {
  return (
    <section id="inicio" className={styles.hero}>
      <div className={styles.heroBg} aria-hidden="true">
        <div className={styles.bgGrid} />
        <div className={styles.bgGlow1} />
        <div className={styles.bgGlow2} />
        <div className={styles.bgCornerTL} />
        <div className={styles.bgCornerBR} />
      </div>

      <div className={styles.heroContainer}>
        {/* ── Left: Text content ── */}
        <div className={styles.heroLeft}>
          <div className={styles.heroBadge}>
            <span className={styles.badgeDot} />
            <FormattedMessage
              id="hero.badge"
              defaultMessage="Plataforma de Visualização 4D"
            />
          </div>

          <h1 className={styles.heroTitle}>
            <FormattedMessage id="hero.title.part1" defaultMessage="Seu cliente enxerga o valor real. " />
            <span className={styles.heroTitleAccent}>
              <FormattedMessage id="hero.title.highlight1" defaultMessage="Um link. Zero instalação. Tudo no celular ou no PC." />
            </span>
          </h1>

          <p className={styles.heroDescription}>
            <FormattedMessage id="hero.description" defaultMessage="Crie o projeto pelo WhatsApp, envie os arquivos e receba o link." />
          </p>

          <div className={styles.heroCtas}>
            <CtaButton href="/register" variant="primary">
              <FormattedMessage id="hero.button" defaultMessage="Começar agora — grátis" />
            </CtaButton>
            <ScrollLink
              to="como-funciona"
              spy
              smooth="easeInOutQuad"
              offset={-76}
              duration={500}
              className={styles.heroSecondaryBtn}
            >
              <FormattedMessage id="hero.buttonSecondary" defaultMessage="Ver como funciona" />
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M7 2.5v9M2.5 7l4.5 4.5 4.5-4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </ScrollLink>
          </div>

          <div className={styles.heroTrust}>
            <span className={styles.trustItem}>
              <span className={styles.trustDot} />
              <FormattedMessage id="hero.trust1" defaultMessage="10.000+ projetos" />
            </span>
            <span className={styles.trustItem}>
              <span className={styles.trustDot} />
              <FormattedMessage id="hero.trust2" defaultMessage="Sem instalação" />
            </span>
            <span className={styles.trustItem}>
              <span className={styles.trustDot} />
              <FormattedMessage id="hero.trust3" defaultMessage="Qualquer dispositivo" />
            </span>
          </div>
        </div>

        {/* ── Right: CSS Visualization Mockup ── */}
        <div className={styles.heroRight}>
          <div className={styles.heroMockup}>
            <div className={styles.mockupChrome}>
              <div className={styles.mockupDots}>
                <span /><span /><span />
              </div>
              <div className={styles.mockupUrl}>vertex4d.ai/shared?token=8f2a4b…</div>
            </div>

            <div className={styles.mockupMap}>
              <div className={styles.mapGrid} aria-hidden="true" />
              <div className={styles.mapPin}>
                <div className={styles.pinRing} />
                <div className={styles.pinDot} />
              </div>
              <div className={styles.mapLabel1}>Alt: 247m</div>
              <div className={styles.mapLabel2}>Área: 12.4 ha</div>
            </div>

            <div className={styles.mockupBar}>
              <span className={styles.barDot} />
              <span className={styles.barText}>
                <FormattedMessage id="hero.mockup.status" defaultMessage="247 arquivos processados" />
              </span>
            </div>
          </div>

          {/* Floating status chips */}
          <div className={styles.floatChip1}>
            <span>📷</span>
            <span><FormattedMessage id="hero.chip.photos" defaultMessage="247 fotos" /></span>
          </div>
          <div className={styles.floatChip2}>
            <span>🤖</span>
            <span><FormattedMessage id="hero.chip.ai" defaultMessage="Relatório IA" /></span>
          </div>
          <div className={styles.floatChip3}>
            <span>🔗</span>
            <span><FormattedMessage id="hero.chip.link" defaultMessage="Link gerado" /></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default injectIntl(HeroSection);
